import BaseLoader from 'components/atoms/base-loader';
import classNames from 'classnames';

import styles from './styles.module.scss';

import type { FC, RefObject } from 'react';

interface Props {
  isLoading: boolean;
  waveformRef: RefObject<HTMLDivElement>;
}

const Waveform: FC<Props> = ({ isLoading, waveformRef }) => {
  return (
    <div className={styles['waveform-wrapper']}>
      <div className={styles['waveform-loader']}>
        <BaseLoader loading={isLoading} />
      </div>
      <div
        ref={waveformRef}
        className={classNames(styles['waveform-container'], {
          [styles.loading]: isLoading,
        })}
      />
    </div>
  );
};

export default Waveform;
